export default __webpack_public_path__ + "static/media/25.07e62ec6.jpg";